<template>
  <div>
    <iframe :class="iframeClass" src="https://bmfw.www.gov.cn/yqfxdjcx/risk.html" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  props: {
    iframeClass: {
      type: String,
      default: 'third-iframe'
    }
  }
}
</script>

<style lang="less" scoped>
.third-iframe {
  min-width: 100vw;
  min-height: 100vh;
}
</style>